// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"8124914f","106":"fc88b1d3"}[chunkId] + ".chunk.css";
};